// extracted by mini-css-extract-plugin
export default {"FailedPageContainer":"FailedPage_FailedPageContainer__bh0WC","header":"FailedPage_header__oRJId","message":"FailedPage_message__YXu5o"};